import { SearchSelectField } from '@/components/ui/SearchSelectField/SearchSelectField';
import { api } from '@/api/client';
import type { User } from '@/api/client';
import { userDisplayNameOrPlaceholder } from '@/utils/userDisplayName';

const PAGE = 25;

interface DateLogChangedByFieldProps {
  value: User | null;
  onChange: (u: User | null) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function DateLogChangedByField({
  value,
  onChange,
  disabled,
  placeholder = 'Пользователь',
}: DateLogChangedByFieldProps) {
  return (
    <SearchSelectField<User>
      value={value}
      onChange={onChange}
      getOptionLabel={userDisplayNameOrPlaceholder}
      placeholder={placeholder}
      disabled={disabled}
      queryKey={['users', 'date-log-changed-by'] as const}
      fetchPage={(q, page) => api.users.list(q || undefined, { limit: PAGE, offset: page * PAGE })}
      minSearchLength={0}
      allowEmptySearch
    />
  );
}
